import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import ExploreMovies from '@/views/ExploreMovies';
import Celebs from '@/views/Celebs';
import Search from '@/views/Search';
import NotFound from '@/views/NotFound';
import MovieDetails from '@/views/MovieDetails';
import CelebDetails from '@/views/CelebDetails';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    components: { default: Home, header: Navbar, footer: Footer },
  },
  {
    path: '/movies',
    name: 'ExploreMovies',
    components: { default: ExploreMovies, header: Navbar },
    children: [
      {
        path: '',
        name: 'Popular',
        component: () => import('@/views/ExploreMovies/Popular'),
      },
      {
        path: 'trending',
        component: () => import('@/views/ExploreMovies/Trending'),
      },
      {
        path: 'upcoming',
        component: () => import('@/views/ExploreMovies/Upcoming'),
      },
      {
        path: 'top-rated',
        name: 'TopRated',
        component: () => import('@/views/ExploreMovies/TopRated'),
      },
    ],
  },
  {
    path: '/movies/:id',
    name: 'MovieDetails',
    components: { default: MovieDetails, header: Navbar },
    children: [
      {
        path: '',
        component: () => import('@/views/MovieDetails/Movie'),
      },
      { path: 'casts', component: () => import('@/views/MovieDetails/Casts') },
    ],
  },
  {
    path: '/celebs',
    name: 'Celebs',
    components: { default: Celebs, header: Navbar },
  },
  {
    path: '/celebs/:id',
    name: 'CelebDetails',
    components: { default: CelebDetails, header: Navbar },
  },
  {
    path: '/search',
    name: 'Search',
    components: { default: Search, header: Navbar, footer: Footer },
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    components: { default: NotFound, header: Navbar, footer: Footer },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        resolve({
          el: to.hash,
          top: 180,
          behavior: 'smooth',
        });
      });
    }

    return savedPosition ?? { top: 0, behavior: 'smooth' };
  },
});

export default router;
